import { useEffect, useRef, useState } from "react";

function ShareARoom() {

  const [address, setAddress] = useState("");
  const [fullAddress, setFullAddress] = useState("");
  const [tooltipVisible, setTooltipVisible] = useState(false);

  useEffect(() => {
    setAddress(window.location.host + window.location.pathname);
    setFullAddress(window.location.href);
  }, []);

  const ref = useRef();

  const showTooltip = () => {
    setTooltipVisible(true);
    setTimeout(() => {
      setTooltipVisible(false);
    }, 4000); // Adjust the timeout duration (in milliseconds) as needed
  };

  const handleCopy = () => {

    ref.current.select();
    ref.current.setSelectionRange(0, 99999); // For mobile devices

    // Copy the text inside the text field
    navigator.clipboard.writeText(ref.current.value);
    showTooltip();
  };

  return (
    <div className='share-a-room' >
      <label>Invite others</label>
      <input className="room-address-input" ref={ref} value={fullAddress}></input>
      {tooltipVisible && <div className="share-a-room-info">Link copied!</div>}
      <div className="room-address-container">
        <div className="room-address">{address}</div>
        <button className="room-address-button" title="Copy link" onClick={handleCopy}><img alt="copy ico" className="copy-ico" src="copy-ico.webp"></img></button>
      </div>
    </div>
  );
}

export default ShareARoom; 
